import { useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";

const isSignedIn = () => Boolean(localStorage.getItem("userData"));

export default function NotFoundPage() {
  const navigate = useNavigate();
  const signedIn = isSignedIn();

  return (
    <main
      className="flex min-h-screen items-center justify-center bg-slate-50 p-6"
      data-testid="not-found-page-main"
    >
      <section className="mx-auto flex max-w-xl flex-col items-center rounded-2xl border border-gray-200 bg-white px-6 py-12 text-center shadow-sm">
        <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gray-100 text-gray-500">
          <Compass size={28} />
        </div>

        <p className="mb-1 text-sm font-semibold text-red-600">404</p>

        <h1
          className="mb-2 text-lg font-semibold text-slate-900"
          data-testid="not-found-title-heading"
        >
          Page not found
        </h1>

        <p className="mb-6 max-w-sm text-sm leading-6 text-gray-500">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <button
          type="button"
          onClick={() => navigate(signedIn ? "/dashboard" : "/", { replace: true })}
          className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-red-700"
          data-testid="not-found-home-button"
        >
          {signedIn ? "Go to Dashboard" : "Go to Home"}
        </button>
      </section>
    </main>
  );
}
